var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMsg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#8995A0",
  fillRule: "evenodd",
  d: "M17 4v7c0 1.1-.9 2-2 2H6l-4 4V4c0-1.1.9-2 2-2h11c1.1 0 2 .9 2 2m2 2h1c1.1 0 2 .9 2 2v14l-4-4H8c-1.1 0-2-.9-2-2v-1h12c.55 0 1-.45 1-1z",
  clipRule: "evenodd"
})));
export { SvgMsg as ReactComponent };
export default __webpack_public_path__ + "Msg.0bb652b8.svg";